import eachElement from 'Utils/eachElement.js';

const setUpNav = () => {
	const detailContainer = document.querySelector('#header .is-platform .detail-container');

	if (detailContainer) {
		/* Handle detail container size */
		const resizeDetailContainer = () => {
			detailContainer.style.minHeight = `${detailContainer.offsetHeight}px`;
		};

		window.addEventListener('resize', resizeDetailContainer);
		document.querySelector('#header')?.addEventListener('mouseenter', resizeDetailContainer);


		/* Handle lifecycle hovering */
		const lifecycleDefaultTitle = detailContainer.querySelector('.lifecycle-container .content h4').textContent;
		const lifecycleDefaultDescription = detailContainer.querySelector('.lifecycle-container .content p').textContent;

		eachElement('#header .is-products .navbar-item > a', link => {
			/* Light up lifecycle segments */
			link.addEventListener('mouseenter', () => {
				/* Next animation frame */
				requestAnimationFrame(() => {
					const segments = link.getAttribute('data-segments').split(',');
					for (const segment of segments) {
						const segmentElement = detailContainer.querySelector(`.lifecycle-image .lifecycle-${segment}`);
						if (segmentElement) {
							segmentElement.classList.add('is-active');
						}
					}

					const title = link.querySelector('.media-content h5')?.textContent || link.querySelector('span')?.textContent;
					const description = link.getAttribute('title');

					detailContainer.querySelector('.lifecycle-container .content h4').textContent = title;
					detailContainer.querySelector('.lifecycle-container .content p').textContent = description;
				});
			});

			/* Restore lifecycle segments */
			link.addEventListener('mouseleave', () => {
				for (const section of detailContainer.querySelectorAll('.lifecycle-image .lifecycle')) {
					section.classList.remove('is-active');
				}

				detailContainer.querySelector('.lifecycle-container .content h4').textContent = lifecycleDefaultTitle;
				detailContainer.querySelector('.lifecycle-container .content p').textContent = lifecycleDefaultDescription;
			});
		});

		/* Handle Solutions hovering */
		eachElement('#header .is-solutions .navbar-item > a', link => {
			/* Display description */
			link.addEventListener('mouseenter', () => {
				/* Next animation frame */
				requestAnimationFrame(() => {
					detailContainer.classList.add('is-cloud');

					const title = link.querySelector('span')?.textContent;
					const description = link.getAttribute('title');

					detailContainer.querySelector('.cloud-container .content h4').textContent = title;
					detailContainer.querySelector('.cloud-container .content p').textContent = description;
				});
			});

			/* Restore default state */
			link.addEventListener('mouseleave', () => {
				detailContainer.classList.remove('is-cloud');
			});
		});
	}


	/* Handle mobile navigation */
	const navbarBurger = document.querySelector('.navbar-burger');
	const navbarMenu = document.querySelector('.navbar-menu');

	navbarBurger?.addEventListener('click', event => {
		event.preventDefault();

		/* Toggle button appearance */
		navbarBurger?.classList.toggle('is-active');
		navbarMenu?.classList.toggle('is-active');

		/* Toggle menu visibility */
		document.documentElement.classList.toggle('has-menu-active');
		/* Hide any previous submenu */
		document.documentElement.classList.remove('has-submenu-active');

		return false;
	});

	/* Handle mobile nav back button */
	document.querySelector('.navbar-back')?.addEventListener('click', event => {
		event.preventDefault();
		document.documentElement.classList.remove('has-submenu-active');
		return false;
	});

	/* Handle opening mobile submenus */
	eachElement('.navbar-item.has-dropdown > a', element => {
		element.addEventListener('click', event => {
			if (window.innerWidth <= 1023) {
				event.preventDefault();

				/* Hide other submenus */
				eachElement('.navbar-dropdown', dropdown => {
					dropdown.classList.remove('is-active');
				});

				/* Display this submenu */
				element.parentNode.querySelector('.navbar-dropdown')?.classList.add('is-active');

				/* Move to the submenu */
				document.documentElement.classList.add('has-submenu-active');

				return false;
			}
		});
	});
};

document.addEventListener('DOMContentLoaded', () => {
	setUpNav();
});
